import React from 'react';
import { EssayLabels, EssaysStatus, EssayStatuses } from '../../../scenes/essay/EssayModels';
import { MultiMappingSelect } from './base/MultiMappingSelect';
import { useTranslation } from 'react-i18next';


type EssayOption = {
  value: EssaysStatus;
  label: string;
};

const EssayOptions: EssayOption[] = EssayStatuses.map(status => (
  {
    value: status,
    label: EssayLabels[status].toString()
  }
));


function getOptionValue(option: EssayOption) {
  return option.value;
}

function getOptionLabel(option: EssayOption) {
  return option.label;
}

type EssaySelectProps = {
  value: EssaysStatus[];
  onChange: (roles: EssaysStatus[]) => void;
  onBlur?: () => void;
};

export function EssaySelect(props: EssaySelectProps) {
  const { t } = useTranslation();

  return (
    <MultiMappingSelect<EssayOption, EssaysStatus>
      options={EssayOptions}
      getValue={getOptionValue}
      getLabel={getOptionLabel}
      value={props.value}
      onChange={props.onChange}
      placeholder={t('essay.select-status')}
      onBlur={props.onBlur} />);
}